/* ==========================================================================
   Performance Powders — Neon Drive
   Theme JavaScript. No dependencies.
   ========================================================================== */
(function () {
  'use strict';

  /* ------------------------------------------------------------------
     Sticky "Subscribe & Save 30%" bar — appears only after scrolling
     ------------------------------------------------------------------ */
  function initScrollCta() {
    var bar = document.querySelector('[data-scroll-cta]');
    if (!bar) return;

    var threshold = parseInt(bar.getAttribute('data-offset'), 10) || 400;
    var visible = false;
    var ticking = false;

    function update() {
      var y = window.scrollY || document.documentElement.scrollTop;
      var shouldShow = y > threshold;
      if (shouldShow !== visible) {
        visible = shouldShow;
        bar.classList.toggle('is-visible', visible);
        // The bar is a link. Leaving it in the tab order while it is hidden
        // from the accessibility tree strands keyboard users on a control
        // their screen reader never announces (WCAG 4.1.2), so tab order and
        // aria-hidden are kept in lockstep.
        bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
        bar.setAttribute('tabindex', visible ? '0' : '-1');
      }
      ticking = false;
    }

    bar.setAttribute('tabindex', '-1');

    window.addEventListener('scroll', function () {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(update);
      }
    }, { passive: true });

    update();
  }

  /* ------------------------------------------------------------------
     Scrolling marquee — pause / resume control (WCAG 2.2.2)
     ------------------------------------------------------------------ */
  function initMarquee() {
    document.querySelectorAll('[data-marquee]').forEach(function (marquee) {
      var btn = marquee.querySelector('[data-marquee-pause]');
      if (!btn || btn.getAttribute('data-bound') === 'true') return;
      btn.setAttribute('data-bound', 'true');

      var label = btn.querySelector('[data-marquee-label]');
      var pauseIcon = btn.querySelector('[data-icon="pause"]');
      var playIcon = btn.querySelector('[data-icon="play"]');

      btn.addEventListener('click', function () {
        var paused = marquee.classList.toggle('is-paused');
        btn.setAttribute('aria-pressed', paused ? 'true' : 'false');
        if (label) label.textContent = paused ? 'Resume scrolling text' : 'Pause scrolling text';
        if (pauseIcon) pauseIcon.hidden = paused;
        if (playIcon) playIcon.hidden = !paused;
      });
    });
  }

  /* ------------------------------------------------------------------
     Mobile navigation drawer

     Treated as a modal dialog: focus moves in on open, is trapped while
     open, and returns to the trigger on close. Everything behind it is
     marked inert so keyboard users cannot tab into content they cannot see.
     ------------------------------------------------------------------ */
  function initMobileNav() {
    var nav = document.querySelector('[data-mobile-nav]');
    if (!nav || nav.getAttribute('data-bound') === 'true') return;
    nav.setAttribute('data-bound', 'true');

    var openers = document.querySelectorAll('[data-nav-open]');
    var closers = nav.querySelectorAll('[data-nav-close]');
    var lastTrigger = null;

    function background() {
      return [
        document.querySelector('.site-header'),
        document.getElementById('MainContent'),
        document.querySelector('.site-footer'),
        document.querySelector('[data-scroll-cta]')
      ].filter(Boolean);
    }

    function focusable() {
      var sel = 'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])';
      return Array.prototype.filter.call(nav.querySelectorAll(sel), function (el) {
        return el.offsetWidth > 0 || el.offsetHeight > 0;
      });
    }

    function open(e) {
      lastTrigger = (e && e.currentTarget) || openers[0] || null;
      nav.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      openers.forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      background().forEach(function (el) { el.setAttribute('inert', ''); });
      var items = focusable();
      if (items.length) items[0].focus();
    }

    function close() {
      if (!nav.classList.contains('is-open')) return;
      nav.classList.remove('is-open');
      document.body.style.overflow = '';
      openers.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      // Clear inert BEFORE restoring focus, or the trigger is still
      // unfocusable at the moment we try to focus it.
      background().forEach(function (el) { el.removeAttribute('inert'); });
      if (lastTrigger) lastTrigger.focus();
    }

    openers.forEach(function (b) { b.addEventListener('click', open); });
    closers.forEach(function (b) { b.addEventListener('click', close); });
    nav.addEventListener('click', function (e) { if (e.target === nav) close(); });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && nav.classList.contains('is-open')) close();
    });

    nav.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var items = focusable();
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    });
  }

  /* ------------------------------------------------------------------
     Form status banners — move focus to the result after a submit

     Shopify contact forms post and reload, so an aria-live region would
     never fire. Focusing the banner is what actually tells a screen reader
     user whether their submission worked.
     ------------------------------------------------------------------ */
  function initFormStatus() {
    var banner = document.querySelector('[data-form-status]');
    if (!banner || banner.getAttribute('data-bound') === 'true') return;
    banner.setAttribute('data-bound', 'true');
    banner.setAttribute('tabindex', '-1');
    banner.focus();
  }

  /* ------------------------------------------------------------------
     Quantity steppers
     ------------------------------------------------------------------ */
  function initQty() {
    document.querySelectorAll('[data-qty]').forEach(function (widget) {
      var input = widget.querySelector('input');
      if (!input) return;
      widget.querySelectorAll('[data-qty-step]').forEach(function (btn) {
        if (btn.getAttribute('data-bound') === 'true') return;
        btn.setAttribute('data-bound', 'true');
        btn.addEventListener('click', function () {
          var step = parseInt(btn.getAttribute('data-qty-step'), 10);
          var min = parseInt(input.getAttribute('min'), 10) || 1;
          var next = (parseInt(input.value, 10) || min) + step;
          input.value = next < min ? min : next;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  /* ------------------------------------------------------------------
     Scroll reveal
     ------------------------------------------------------------------ */
  function initReveal() {
    var items = document.querySelectorAll('.reveal');
    if (!items.length) return;
    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    items.forEach(function (el) { io.observe(el); });
  }

  /* ------------------------------------------------------------------
     Money formatting
     ------------------------------------------------------------------ */
  function formatMoney(cents, format) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var amount = parts.join('.');
    if (format && format.indexOf('{{') !== -1) {
      return format.replace(/\{\{\s*\w+\s*\}\}/, amount);
    }
    return '$' + amount;
  }

  /* ------------------------------------------------------------------
     Product form: flavor variants + one-time vs Subscribe & Save
     ------------------------------------------------------------------ */
  function initProductForm() {
    document.querySelectorAll('[data-product-form]').forEach(function (root) {
      var dataEl = root.querySelector('[data-product-json]');
      if (!dataEl) return;

      var product;
      try { product = JSON.parse(dataEl.textContent); } catch (e) { return; }

      var moneyFormat = root.getAttribute('data-money-format') || '${{amount}}';
      var firstPct = parseFloat(root.getAttribute('data-first-pct')) || 0;
      var extraPct = parseFloat(root.getAttribute('data-first-extra-pct')) || 0;
      var recurPct = parseFloat(root.getAttribute('data-recurring-pct')) || 0;

      var variantInput = root.querySelector('[data-variant-id]');
      var planInput = root.querySelector('[data-selling-plan-input]');
      var submitBtn = root.querySelector('[data-add-button]');
      var submitText = root.querySelector('[data-add-button-text]');
      var priceOut = root.querySelector('[data-price-now]');
      var compareOut = root.querySelector('[data-price-compare]');
      var savingsOut = root.querySelector('[data-price-savings]');
      var flavorLabel = root.querySelector('[data-flavor-label]');
      var flavorInputs = root.querySelectorAll('[data-flavor-input]');
      var planInputs = root.querySelectorAll('[data-plan-input]');
      var frequency = root.querySelector('[data-frequency-select]');
      var mediaRoot = document.querySelector('[data-product-media]');

      function currentVariant() {
        var checked = root.querySelector('[data-flavor-input]:checked');
        var id = checked ? checked.value : (variantInput ? variantInput.value : null);
        for (var i = 0; i < product.variants.length; i++) {
          if (String(product.variants[i].id) === String(id)) return product.variants[i];
        }
        return product.variants[0];
      }

      function currentPlan() {
        var checked = root.querySelector('[data-plan-input]:checked');
        return checked ? checked : null;
      }

      function swapMedia(variant) {
        if (!mediaRoot || !variant || !variant.featured_image) return;
        var main = mediaRoot.querySelector('[data-media-main]');
        if (main && variant.featured_image.src) {
          main.src = variant.featured_image.src;
          main.alt = variant.featured_image.alt || variant.title;
        }
      }

      function render() {
        var variant = currentVariant();
        var plan = currentPlan();
        var isSub = plan && plan.getAttribute('data-plan-type') === 'subscription';

        if (variantInput && variant) variantInput.value = variant.id;

        if (planInput) {
          planInput.value = isSub ? (plan.getAttribute('data-selling-plan') || '') : '';
          planInput.disabled = !planInput.value;
        }

        if (flavorLabel) {
          var checkedFlavor = root.querySelector('[data-flavor-input]:checked');
          flavorLabel.textContent = checkedFlavor
            ? checkedFlavor.getAttribute('data-flavor-name')
            : (variant ? variant.title : '');
        }

        var base = variant ? variant.price : 0;
        var now = base;

        if (isSub) {
          // Prefer the real selling plan allocation price when Shopify
          // Subscriptions is configured; fall back to the theme's percentage.
          var planId = plan.getAttribute('data-selling-plan');
          var allocation = null;
          if (planId && variant && variant.selling_plan_allocations) {
            for (var a = 0; a < variant.selling_plan_allocations.length; a++) {
              if (String(variant.selling_plan_allocations[a].selling_plan_id) === String(planId)) {
                allocation = variant.selling_plan_allocations[a];
                break;
              }
            }
          }
          if (allocation) {
            // The allocation is the RECURRING price. A first-order-only
            // automatic discount is applied at cart/checkout and is not visible
            // here, so without this the page quotes a higher price than the
            // customer is charged. extraPct mirrors that discount.
            now = allocation.price;
            // Shopify truncates the discount amount in cents rather than
            // rounding it (17.65% of 3739 = 659.93 becomes 659, not 660), so
            // floor the discount and subtract, instead of rounding the result.
            // Rounding here quotes $30.79 against a $30.80 charge.
            if (extraPct > 0) now = now - Math.floor(now * extraPct / 100);
          } else {
            var pct = parseFloat(plan.getAttribute('data-discount-pct'));
            if (isNaN(pct)) pct = firstPct;
            now = Math.round(base * (1 - pct / 100));
          }
        }

        if (priceOut) priceOut.textContent = formatMoney(now, moneyFormat);
        if (compareOut) {
          if (now < base) {
            compareOut.textContent = formatMoney(base, moneyFormat);
            compareOut.hidden = false;
          } else {
            compareOut.hidden = true;
          }
        }
        if (savingsOut) {
          if (now < base) {
            savingsOut.textContent = 'You save ' + formatMoney(base - now, moneyFormat) + ' today';
            savingsOut.hidden = false;
          } else {
            savingsOut.hidden = true;
          }
        }

        var available = variant && variant.available;
        if (submitBtn) {
          submitBtn.disabled = !available;
          submitBtn.setAttribute('aria-disabled', available ? 'false' : 'true');
        }

        // Back-in-stock capture: only meaningful when the variant can't be
        // bought. Tag carries the flavor so the list can be segmented per
        // variant rather than one undifferentiated pile of addresses.
        var notify = root.querySelector('[data-notify]');
        if (notify) {
          var posted = notify.querySelector('.notify__done');
          notify.hidden = available && !posted;
          var tagsInput = notify.querySelector('[data-notify-tags]');
          if (tagsInput && variant && variant.title) {
            tagsInput.value = 'back-in-stock, back-in-stock: ' + variant.title;
          }
        }
        if (submitText) {
          if (!available) {
            submitText.textContent = 'Sold out';
          } else if (isSub) {
            submitText.textContent = 'Subscribe & save — ' + formatMoney(now, moneyFormat);
          } else {
            submitText.textContent = 'Add to cart — ' + formatMoney(now, moneyFormat);
          }
        }

        swapMedia(variant);

        root.dispatchEvent(new CustomEvent('pp:variant:change', {
          bubbles: true,
          detail: { variant: variant, subscription: isSub }
        }));
      }

      flavorInputs.forEach(function (i) { i.addEventListener('change', render); });
      planInputs.forEach(function (i) { i.addEventListener('change', render); });
      if (frequency) {
        frequency.addEventListener('change', function () {
          var sub = root.querySelector('[data-plan-input][data-plan-type="subscription"]');
          if (sub) sub.setAttribute('data-selling-plan', frequency.value);
          render();
        });
      }

      render();
    });
  }

  /* ------------------------------------------------------------------
     Product gallery thumbnails
     ------------------------------------------------------------------ */
  function initGallery() {
    var root = document.querySelector('[data-product-media]');
    if (!root) return;
    var main = root.querySelector('[data-media-main]');
    root.querySelectorAll('[data-media-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.getAttribute('data-src');
        if (main && src) { main.src = src; main.alt = thumb.getAttribute('data-alt') || ''; }
        root.querySelectorAll('[data-media-thumb]').forEach(function (t) {
          t.setAttribute('aria-current', t === thumb ? 'true' : 'false');
        });
      });
    });
  }

  /* ------------------------------------------------------------------
     Tank-top design picker (line item property on the shop page)
     ------------------------------------------------------------------ */
  function initGiftPicker() {
    document.querySelectorAll('[data-gift-picker]').forEach(function (picker) {
      var out = picker.querySelector('[data-gift-value]');
      picker.querySelectorAll('[data-gift-option]').forEach(function (opt) {
        opt.addEventListener('change', function () {
          if (out) out.value = opt.value;
        });
      });
    });
  }

  /* ------------------------------------------------------------------
     Cart line quantity auto-submit
     ------------------------------------------------------------------ */
  function initCartForm() {
    var form = document.querySelector('[data-cart-form]');
    if (!form) return;
    form.querySelectorAll('[data-cart-qty]').forEach(function (input) {
      input.addEventListener('change', function () { form.submit(); });
    });
  }

  /* ------------------------------------------------------------------
     Header shrink on scroll
     ------------------------------------------------------------------ */
  function initHeaderState() {
    var header = document.querySelector('.site-header');
    if (!header) return;
    var ticking = false;
    function update() {
      header.classList.toggle('is-scrolled', (window.scrollY || 0) > 12);
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
    }, { passive: true });
    update();
  }

  /* ------------------------------------------------------------------
     Boot
     ------------------------------------------------------------------ */
  function boot() {
    initScrollCta();
    initMarquee();
    initMobileNav();
    initFormStatus();
    initQty();
    initReveal();
    initProductForm();
    initGallery();
    initGiftPicker();
    initCartForm();
    initHeaderState();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Re-init inside the theme editor when a section is re-rendered
  document.addEventListener('shopify:section:load', boot);

  window.PP = { formatMoney: formatMoney, boot: boot };
})();
